import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

interface SortableItemProps {
    id: string;
    children: (handleProps: { listeners: any; attributes: any }) => React.ReactNode;
    as?: 'li' | 'div';
    style?: React.CSSProperties;
    className?: string;
}

export const SortableItem: React.FC<SortableItemProps> = ({ id, children, as = 'li', style, className }) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });
    const composedStyle: React.CSSProperties = {
        ...style,
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
    };
    const Tag: any = as;
    return (
        <Tag ref={setNodeRef} style={composedStyle} className={className}>
            {children({ listeners, attributes })}
        </Tag>
    );
};

export const DragHandle: React.FC<{ listeners: any; attributes: any; title?: string }> = ({ listeners, attributes, title = 'Trascina per riordinare' }) => (
    <span
        {...listeners}
        {...attributes}
        title={title}
        style={{ cursor: 'grab', userSelect: 'none', color: '#888', fontSize: '1rem', padding: '0 .25rem', touchAction: 'none' }}
        onClick={e => e.stopPropagation()}
    >
        ⋮⋮
    </span>
);
